import { BaseUniDriver } from '@wix/wix-ui-test-utils/dist/types/base-driver';
import {
  ButtonCoreDriver,
  buttonCoreDriverFactory,
} from '../Button/ButtonCore/ButtonCore.uni.driver';
import {
  isElementFocused,
  baseUniDriverFactory,
} from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';

export interface IconButtonUniDriver extends BaseUniDriver {
  isButtonDisabled: ButtonCoreDriver['isButtonDisabled'];
  isFocused: () => Promise<boolean>;
}

export const iconButtonDriverFactory = (base: UniDriver) => {
  const buttonDriver = buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),
    /** returns true if button disabled */
    isButtonDisabled: buttonDriver.isButtonDisabled,
    /**
     * Checks whether button is focused
     * @returns {Promise<boolean>}
     */
    isFocused: async () => isElementFocused(base),
  };
};
